import { useGSAP } from "../utils/gsapLoader";
import PageHero from "../components/PageHero";
import StakeholderLogosSection from "../components/StakeholderLogosSection";

export default function StakeholdersPage() {
  const gsap = useGSAP();
  return (
    <div className="page-fade">
      <PageHero title="Key Stakeholders" tag="National Security Ecosystem" subtitle="Organizations and agencies engaged in national security, united in strengthening India's homeland defence."/>
      <StakeholderLogosSection gsap={gsap} showAll={true}/>
    </div>
  );
}
